import { Flex, IconTypes, isIconType } from "@capioweb/ui-components"
import React from "react"
import {
	BooleanProperty,
	LinkProperty,
	StringProperty,
} from "../../@types/EpiFoundationSpa/Property"
import { MostVisitedDiagnosesCard } from "./MostVisitedDiagnosesCard"

interface DiagnoseLink {
	icon: string
	header: string
	tags: string[]
	url: string
}

interface CapioNexusVisitedDiagnosesBlockProps {
	ctaLink: LinkProperty
	diagnoses: DiagnoseLink[]
	heading: StringProperty
	ingress: StringProperty
	marginBottom: BooleanProperty
}

const getIcon = (icon: string): IconTypes | undefined => {
	if (isIconType(icon)) {
		return icon as IconTypes
	}
	return undefined
}

const CapioNexusVisitedDiagnosesBlock: React.FC<CapioNexusVisitedDiagnosesBlockProps> =
	({ ctaLink, diagnoses, heading, ingress, marginBottom }) => {
		return (
			<Flex flex={1} mb={marginBottom?.value ? 3 : 0}>
				<MostVisitedDiagnosesCard
					cta={{
						text: ctaLink ? ctaLink?.text : "",
						href: ctaLink ? ctaLink?.href : "",
					}}
					header={heading.value}
					description={ingress.value}
					items={diagnoses.map((diagnose) => ({
						icon: getIcon(diagnose.icon),
						text: diagnose.header,
						href: diagnose.url,
					}))}
				/>
			</Flex>
		)
	}

export { CapioNexusVisitedDiagnosesBlock }
